import * as React from 'react';
import { rgba } from 'polished';
import styled from 'styled-components';

import { ReactComponent as QuoteIcon } from '../../images/icons/icon-quote.svg';

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  p {
    text-align: center;
  }

  img {
    ${({ theme }) => theme.customerLogoColor};
  }
`;

const Quote = styled.div`
  display: flex;
  align-items: center;
  font-family: ${({ theme }) => theme.fontFamily.MONO};
  font-size: 32px;
  opacity: 1;
  margin: 25px 0 15px;
  width: 100%;

  &::before,
  &::after {
    content: '';
    flex: 1 1 auto;
    display: flex;
    height: 1px;
  }

  &::before {
    margin-right: 10px;
    background: linear-gradient(
      90deg,
      transparent 0%,
      ${({ theme }) => rgba(theme.highlightColor, 0.5)} 95%
    );
  }

  &::after {
    margin-left: 10px;
    background: linear-gradient(
      -90deg,
      transparent 0%,
      ${({ theme }) => rgba(theme.highlightColor, 0.6)} 95%
    );
  }
`;

const Author = styled.div`
  padding-top: 20px;

  p:first-child {
    color: ${({ theme }) => theme.fontColor.LOUD};
    font-size: ${({ theme }) => theme.fontSize.MEDIUM};
    font-weight: 600;
    margin-bottom: 5px;
  }

  p:last-child {
    color: ${({ theme }) => theme.fontColor.MUTED};
    line-height: 18px;
  }
`;

export interface CustomerQuoteType {
  author: string;
  customer: {
    name: string;
  };
  quote: {
    quote: string;
  };
}

interface CustomerQuoteProps {
  author?: string;
  customerName: string;
  logoPath?: string;
  quote: string;
}

export const CustomerQuote: React.ComponentType<CustomerQuoteProps> =
  React.memo(({ logoPath, customerName, quote, author }) => {
    return (
      <Wrapper>
        {logoPath && <img alt={customerName} src={logoPath} />}
        <Quote>
          <QuoteIcon />
        </Quote>
        <p>"{quote}"</p>
        {author && (
          <Author>
            <p>{author}</p>
            <p>{customerName}</p>
          </Author>
        )}
      </Wrapper>
    );
  });
